export default function DirectCTASection() {
  const handleScrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePhoneCall = () => {
    window.location.href = 'tel:080-7347-9482';
  };

  const handleLineConsult = () => {
    window.open('https://lin.ee/FOUdDfw', '_blank');
  };

  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-5xl mx-auto text-center space-y-10">
        {/* Catchphrase with Mincho Font */}
        <h2 
          className="text-4xl md:text-5xl lg:text-6xl font-light leading-relaxed tracking-wide text-[#3E2723]"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          思い出を、次へ。
          <br />
          <span className="text-3xl md:text-4xl lg:text-5xl">
            ご実家の整理をトータルで支えます。
          </span>
        </h2>

        {/* CTA Buttons */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 pt-6">
          {/* Primary CTA: Free Consultation */}
          <button
            onClick={handleScrollToContact}
            className="group relative w-full md:w-auto px-10 py-5 bg-gradient-to-r from-[#00A58E] to-[#008C7A] text-white text-lg font-bold rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <span className="flex items-center justify-center gap-3">
              <i className="ri-file-list-3-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              無料査定を申し込む
            </span>
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#FFD700] to-[#FFA500] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>

          {/* Phone CTA */}
          <button
            onClick={handlePhoneCall}
            className="group relative w-full md:w-auto px-10 py-5 bg-white border-2 border-[#00A58E] text-[#00A58E] text-lg font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:bg-[#00A58E] hover:text-white whitespace-nowrap"
          >
            <span className="flex items-center justify-center gap-3">
              <i className="ri-phone-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              電話で相談
            </span>
          </button>

          {/* LINE CTA */}
          <button
            onClick={handleLineConsult}
            className="group relative w-full md:w-auto px-10 py-5 bg-[#00B900] text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <span className="flex items-center justify-center gap-3">
              <i className="ri-message-3-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              LINEで相談
            </span>
            <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 pt-8 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#00A58E] text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>出張費・査定費 完全無料</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-[#00A58E] text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>24時間以内に返信</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-close-circle-line text-[#00A58E] text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>しつこい営業は一切なし</span>
          </div>
        </div>
      </div>
    </section>
  );
}